import React from "react";
import { getFullName } from "../../../careprovider/visits/utils";
import { Tag } from "antd";
import { getUserAge } from "../../../../utils/userdatautils";
import TruncatedListWithPopover from "../TruncatedListWithPopover";
import { useGetRole } from "../../../generic/hooks/useGetRole";
import { useNavigate } from "react-router-dom";
import { RoleToLinkMapper } from "../../../utils/UrlUtils";

const VolunteerDetails = ({ assignedOpportunities, showVolunteerInfo }) => {
  const role = useGetRole();
  const navigate = useNavigate();
  const tagsData =
    assignedOpportunities[0]?.workforce?.metadata &&
    JSON.parse(assignedOpportunities[0]?.workforce?.metadata);
  const tagMapper = {
    maritalStatus: (value) => value && <Tag key="maritalStatus">{value}</Tag>,
  };
  const workforceAge =
    assignedOpportunities[0]?.workforce?.birthDate &&
    getUserAge(assignedOpportunities[0]?.workforce?.birthDate);

  const volunteers = assignedOpportunities?.map((item) =>
    getFullName(item?.workforce?.givenName, item?.workforce?.familyName),
  );

  const handleNavigation = () => {
    navigate(
      `${RoleToLinkMapper(role)}volunteer-profile?identifier=${
        assignedOpportunities[0]?.workforceIdentifier
      }`,
    );
  };

  return (
    <>
      {assignedOpportunities?.length === 1 ? (
        <div className="patient-details-card">
          <div className="patient-details-card-header">
            <span
              className="patient-details-card-primary-title cursor-pointer"
              onClick={handleNavigation}
            >
              {getFullName(
                assignedOpportunities[0]?.workforce.givenName,
                assignedOpportunities[0]?.workforce.familyName,
              )}
            </span>
          </div>
          {showVolunteerInfo && (
            <>
              <div className="patient-details-card-header">
                <span>
                  {assignedOpportunities[0]?.workforce.gender &&
                    `${assignedOpportunities[0]?.workforce.gender?.charAt(
                      0,
                    )}${assignedOpportunities[0]?.workforce.gender
                      ?.slice(1)
                      .toLowerCase()},`}
                  {workforceAge &&
                    !isNaN(workforceAge) &&
                    ` Age ${workforceAge}`}
                </span>
              </div>

              <div className="patient-details-card-header">
                {tagsData && (
                  <div className="mt-1">
                    {Object.keys(tagMapper)
                      ?.map((item) => tagMapper[item]?.(tagsData[item]))
                      .filter(Boolean)}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      ) : (
        <div className="patient-details-card-header">
          <TruncatedListWithPopover
            dataList={volunteers}
            dataToBeDisplayed={3}
            direction="vertical"
          />
        </div>
      )}
    </>
  );
};

export default VolunteerDetails;
